module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('vue-headful', {
    attrs: {
      "title": "SGP - Impressão da Proposta"
    }
  }), _vm._v(" "), _c('div', [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Impressão da Proposta\n        "), _vm._v(" "), (_vm.bloqueiaBotoes === false) ? _c('span', [_c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "disabled": false,
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.imprimirRelatorio($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Imprimir ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "info",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onDownloadZIP($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Baixar documentos ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "error",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closewindow($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Sair do relatório ")])], 1) : _vm._e()]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Proposta',
        href: '/proposta/lista'
      }, {
        text: 'Imprime',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    attrs: {
      "id": "proposta"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.ultimaTarefaEntidade) ? _c('div', {
    staticClass: "box-body"
  }, [(_vm._.isUndefined(_vm.ultimaTarefaEntidade) || _vm._.isNull(_vm.ultimaTarefaEntidade.termino)) ? _c('span', {
    staticClass: "ressaltar atencao"
  }, [_vm._v("Essa proposta ainda não foi enviada para Fundação BB")]) : _c('span', [_vm._v("\n                  Essa proposta foi enviada por\n                  "), (_vm.ultimaTarefaEntidade.usuario) ? _c('span', {
    staticClass: "ressaltar atencao"
  }, [_vm._v(_vm._s(_vm.ultimaTarefaEntidade.usuario.ds_nome_usuario))]) : _vm._e(), _vm._v(" em\n                  "), _c('span', {
    staticClass: "ressaltar atencao"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.ultimaTarefaEntidade.termino, "DD/MM/YYYY")))]), _vm._v(" às\n                  "), _c('span', {
    staticClass: "ressaltar atencao"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.ultimaTarefaEntidade.termino, "HH:mm")))])])]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Resumo do Projeto")]), _vm._v(" "), _c('div', [(_vm._.isString(_vm.proposta.ds_codigo_projeto_erp)) ? _c('table', {
    staticClass: "table table-condensed table-bordered m0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cabecalho w30"
  }, [_vm._v("Número do Projeto")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.proposta.ds_codigo_projeto_erp))])])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered m0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cabecalho w30"
  }, [_vm._v("Nome do Projeto")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.proposta.ds_nome))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered m0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cabecalho w30"
  }, [_vm._v("Período de Realização do Projeto")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.ehNulo(_vm.proposta.dt_assinatura_convenio, _vm.proposta.dt_data_inicial), 'MM/YYYY')) + "  a  " + _vm._s(_vm.proposta.dataFinal) + "  (" + _vm._s(_vm.proposta.nr_periodos) + " meses)")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered m0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cabecalho w30"
  }, [_vm._v("Recursos do Projeto")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalProjeto)))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalFBB)))]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalCtrp)))]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.proposta.totalParc)))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered m0"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm._.groupBy(_vm.proposta.municipalizacao, function(m) {
    return m.ds_municipio + '/' + m.ds_uf
  })), function(municipio) {
    return _c('tr', [_c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(municipio[0].ds_municipio))]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar w10"
    }, [_vm._v(_vm._s(municipio[0].ds_uf))])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.proposta && _vm.parcelasAdiantamentoExibicao.length > 0) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Parcelas de Adiantamento")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "cabecalho",
    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '10%' : '15%'))
  }, [_vm._v("Parcela")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho",
    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '30%' : '45%'))
  }, [_vm._v("Origem")]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('th', {
    staticClass: "cabecalho",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Fundação")]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('th', {
    staticClass: "cabecalho",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Parceiro Estratégico")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "cabecalho",
    style: ('width: ' + (_vm.exibeDesdobramentoParcelas ? '20%' : '40%'))
  }, [_vm._v("Valor Adiantável")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.parcelasAdiantamentoExibicao), function(adiantamento) {
    return _c('tr', {
      key: 'adiantamento-' + adiantamento.parcela + '-' + adiantamento.origem
    }, [_c('td', {
      staticClass: "ressaltar centralizado"
    }, [_vm._v(_vm._s(adiantamento.parcela))]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar centralizado"
    }, [_vm._v(_vm._s(_vm.rotuloOrigemParcela(adiantamento.origem)))]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
      staticClass: "ressaltar direita"
    }, [(!_vm._.isNil(adiantamento.valor_fbb)) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor_fbb)))]) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
      staticClass: "ressaltar direita"
    }, [(!_vm._.isNil(adiantamento.valor_parc)) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor_parc)))]) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "ressaltar direita"
    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.valor)))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Total adiantável")]), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
    staticClass: "ressaltar direita"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoFundacao)) + "\n                        "), (_vm.totalParcelasAdiantamentoGeral > 0) ? _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoFundacao / _vm.totalParcelasAdiantamentoGeral))) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.exibeDesdobramentoParcelas) ? _c('td', {
    staticClass: "ressaltar direita"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoParceiro)) + "\n                        "), (_vm.totalParcelasAdiantamentoGeral > 0) ? _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoParceiro / _vm.totalParcelasAdiantamentoGeral))) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "ressaltar direita"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("real")(_vm.totalParcelasAdiantamentoGeral)) + "\n                        "), ((_vm._.toNumber(_vm.proposta.totalFBB || 0) + _vm._.toNumber(_vm.proposta.totalParc || 0)) > 0) ? _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("(" + _vm._s(_vm._f("percentage")((_vm.totalParcelasAdiantamentoGeral / (_vm._.toNumber(_vm.proposta.totalFBB || 0) + _vm._.toNumber(_vm.proposta.totalParc || 0))))) + ")")]) : _vm._e()])])], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.proposta && _vm.proposta.entidade) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Entidade Proponente")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cabecalho w30"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_nome))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.proposta.entidade.ds_cnpj)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Natureza Jurídica")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.formaJuridica))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_email))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Contato")]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s((_vm._.has(_vm.proposta.entidade, 'contato') && !_vm._.isEmpty(_vm.proposta.entidade.contato)) ? (_vm.ehNulo(_vm.proposta.entidade.contato.ds_telefone, _vm.proposta.entidade.contato.ds_celular) | _vm.telefone) : ''))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered m0"
  }, [_c('thead', [_c('tr', [(_vm.proposta.entidade.endereco) ? _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Endereço" + _vm._s((_vm.proposta.entidade.endereco.length > 1 ? 's' : '')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Número")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho centralizado"
  }, [_vm._v("UF")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho centralizado"
  }, [_vm._v("CEP")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.entidade.endereco), function(endereco) {
    return _c('tr', [_c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(endereco.ds_rua))]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(endereco.ds_numero))]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(endereco.ds_bairro))]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(endereco.ds_complemento))]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(endereco.ds_cidade))]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar centralizado"
    }, [_vm._v(_vm._s(endereco.ds_estado))]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar centralizado"
    }, [_vm._v(_vm._s(_vm._f("cep")(endereco.ds_cep)))])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.proposta && _vm.proposta.entidade) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Representante Legal da Entidade (que assina pela entidade e tem mandato vigente)")]), _vm._v(" "), _vm._l((_vm.proposta.entidade.dirigentes), function(dirigente) {
    return _c('div', [_c('table', {
      staticClass: "table table-condensed table-bordered lista"
    }, [_c('tbody', [(dirigente.cargo) ? _c('tr', [_c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar w30"
    }, [_vm._v(_vm._s(dirigente.ds_nome))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Cargo")]), _vm._v(" "), (dirigente.cargo.ds_descricao) ? _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(dirigente.cargo.ds_descricao))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("CPF")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(_vm._f("cpf")(dirigente.ds_cpf)))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Final do Mandato")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))])]) : _vm._e(), _vm._v(" "), (dirigente.contato) ? _c('tr', [_c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("RG")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(dirigente.ds_rg) + " - " + _vm._s(dirigente.ds_orgao_emissor) + "/" + _vm._s(dirigente.ds_uf))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Estado Civil")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(dirigente.ds_estado_civil))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Profissão")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(dirigente.ds_profissao))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Telefone")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(_vm._f("telefone")(dirigente.contato.ds_telefone)))])]) : _vm._e(), _vm._v(" "), (dirigente.endereco) ? _c('tr', [_c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Endereço")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(dirigente.endereco.ds_rua) + ", " + _vm._s(dirigente.endereco.ds_numero) + ", " + _vm._s(dirigente.endereco.ds_bairro) + ", " + _vm._s(dirigente.endereco.ds_complemento))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("CEP")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(_vm._f("cep")(dirigente.endereco.ds_cep)))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Cidade/UF")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(dirigente.endereco.ds_cidade) + " / " + _vm._s(dirigente.endereco.ds_uf))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("E-mail")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(dirigente.contato.ds_email))])]) : _vm._e()])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered m0"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "ressaltar"
  }, [_vm._v(_vm._s(_vm.proposta.ds_nome_coordenador))]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar centralizado"
  }, [_vm._v(_vm._s(_vm._f("cpf")(_vm.proposta.ds_cpf_coordenador)))]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar centralizado"
  }, [_vm._v(_vm._s(_vm._f("telefone")(_vm.ehNulo(_vm.proposta.ds_telefone_coordenador, _vm.proposta.ds_celular_coordenador))))]), _vm._v(" "), _c('td', {
    staticClass: "ressaltar centralizado"
  }, [_vm._v(_vm._s(_vm.proposta.ds_email_coordenador))])])])])]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Apresentação da Entidade Proponente")]), _vm._v(" "), _c('div', {
    staticClass: "caixa_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.proposta.ds_apresentacao)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Informação sobre Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
    staticClass: "caixa_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.proposta.ds_territorio)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
    staticClass: "caixa_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.proposta.ds_justificativa)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
    staticClass: "caixa_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.proposta.ds_operacao)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Relacionamento com a Comunidade e Parcerias")]), _vm._v(" "), _c('div', {
    staticClass: "caixa_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.proposta.ds_parceria)
    }
  })]), _vm._v(" "), (_vm.proposta) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Público-alvo do projeto")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-condensed table-bordered m0"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.publicos_alvo), function(publico) {
    return _c('tr', [(publico.fonte.ds_descricao) ? _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(publico.fonte.ds_descricao))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "ressaltar centralizado"
    }, [_vm._v(_vm._s(publico.nr_participantes_diretos))]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar centralizado"
    }, [_vm._v(_vm._s(publico.nr_jovens))]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar centralizado"
    }, [_vm._v(_vm._s(publico.nr_mulheres))])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Objetivos do projeto")]), _vm._v(" "), _c('div', {
    staticClass: "caixa_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.proposta.ds_objetivo_geral)
    }
  })]), _vm._v(" "), (_vm.proposta) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Objetivos, Metas e Atividades")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-condensed m0 obj_met_atv"
  }, [_c('tbody', [_vm._l((_vm.proposta.objetivos), function(objetivo, idxObjetivo) {
    return [_c('tr', {
      staticClass: "objetivo"
    }, [(objetivo.ds_descricao) ? _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "tag"
    }, [_vm._v("objetivo")]), _vm._v(_vm._s(objetivo.ds_descricao))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.proposta.metas), function(meta, idxMeta) {
      return (_vm._.find(meta.objetivos, function(o) {
        return o.ds_descricao === objetivo.ds_descricao
      })) ? [_c('tr', {
        staticClass: "meta"
      }, [(meta.ds_descricao) ? _c('td', [_c('span', {
        staticClass: "tag vertical"
      }, [_vm._v("meta")]), _vm._v(_vm._s(meta.ds_descricao))]) : _vm._e(), _vm._v(" "), _c('td', [_c('span', {
        staticClass: "ressaltar"
      }, [_vm._v(_vm._s(meta.nr_quantidade) + " " + _vm._s(meta.ds_unidade_medida))]), _vm._v(" e indicar a execução como "), _c('span', {
        staticClass: "ressaltar"
      }, [_vm._v(_vm._s(meta.ds_indicadores_execucao))])])]), _vm._v(" "), _vm._l((_vm.proposta.atividades), function(atividade, idxAtividade) {
        return (_vm._.find(atividade.metas, function(m) {
          return m.ds_descricao === meta.ds_descricao
        })) ? [_c('tr', {
          staticClass: "atividade"
        }, [(atividade.descricao) ? _c('td', [_c('span', {
          staticClass: "tag vertical"
        }, [_vm._v("atividade")]), _vm._v(_vm._s(atividade.descricao))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("Executar\n                              "), (atividade.inicio === atividade.termino) ? _c('span', [_vm._v(" no " + _vm._s(atividade.inicio) + "º ")]) : _c('span', [_vm._v(" do " + _vm._s(atividade.inicio) + "º  ao  " + _vm._s(atividade.termino) + "º ")]), _vm._v("\n                              mês e comprovar com "), _c('span', {
          staticClass: "ressaltar"
        }, [_vm._v(_vm._s(atividade.ds_documento_comprobatorio))])])])] : _vm._e()
      }), _vm._v(" "), (!_vm.haObjetivoMeta(_vm.proposta.atividades, 'metas', meta.ds_descricao)) ? [_c('tr', {
        staticClass: "atividade atencao"
      }, [_c('td', {
        attrs: {
          "colspan": "2"
        }
      }, [_vm._v("* Não há atividades para a Meta acima")])])] : _vm._e()] : _vm._e()
    }), _vm._v(" "), (!_vm.haObjetivoMeta(_vm.proposta.metas, 'objetivos', objetivo.ds_descricao)) ? [_c('tr', {
      staticClass: "meta atencao"
    }, [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("* Não há metas para o Objetivo acima")])])] : _vm._e()]
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cronograma de Execução das Atividades")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "cabecalho w40 b1 b4"
  }, [_vm._v("Atividade")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho direita w10 b1"
  }, [_vm._v("Valor total")]), _vm._v(" "), _vm._l((_vm._.range([_vm.start = 0], _vm.proposta.nr_periodos, [_vm.step = 1])), function(mes) {
    return _c('th', {
      staticClass: "centralizado b1 b2 b4",
      style: ('zoom:' + _vm.ganttZoom)
    }, [_vm._v(_vm._s(mes + 1))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.proposta.atividades), function(atividade) {
    return _c('tr', [_c('td', {
      staticClass: "ressaltar b3 b4"
    }, [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('td', {
      staticClass: "direita b3"
    }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(atividade.itens_orcamentos, function(a) {
      return parseFloat(a.quantidade) * parseFloat(a.valor_unitario)
    }))))]), _vm._v(" "), _vm._l((_vm._.range([_vm.start = 0], _vm.proposta.nr_periodos, [_vm.step = 1])), function(m) {
      return _c('td', {
        staticClass: "centralizado b2 b3 b4",
        style: ((m >= (atividade.inicio - 1) && m <= (atividade.termino - 1)) ? 'background: gray !important' : '')
      }, [((m >= (atividade.inicio - 1) && m <= (atividade.termino - 1))) ? _c('span', {
        style: ('zoom:' + _vm.ganttZoom + '; color: gray')
      }, [_c('i', {
        staticClass: "fa fa-circle"
      })]) : _c('span', [_vm._v(" ")])])
    })], 2)
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cursos")]), _vm._v(" "), _vm._l((_vm.proposta.cursos), function(curso) {
    return _c('div', [_c('table', {
      staticClass: "table table-condensed table-bordered lista"
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Título")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar",
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(curso.ds_titulo))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho",
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v("Alunos inscritos em outros cursos deste projeto?")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(('' + curso.outroCurso) === '0' ? 'Não' : 'Sim'))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Carga Horária")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar w10"
    }, [_vm._v(_vm._s(curso.nr_carga_horaria))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Qtde Educadores")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar w10"
    }, [_vm._v(_vm._s(curso.nr_qt_educadores))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Qtde de Turmas")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar w10"
    }, [_vm._v(_vm._s(curso.nr_qt_turmas))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Qtde Alunos por Turma")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar w10"
    }, [_vm._v(_vm._s(curso.nr_qt_alunos_turma))])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "8"
      }
    }, [_c('span', {
      staticClass: "cabecalho"
    }, [_vm._v("Público-alvo")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(curso.ds_publico_alvo))])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "8"
      }
    }, [_c('span', {
      staticClass: "cabecalho"
    }, [_vm._v("Conteúdo Programárico")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(curso.ds_conteudo))])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "8"
      }
    }, [_c('span', {
      staticClass: "cabecalho"
    }, [_vm._v("Detalhamento do perfil/experiência/qualificação dos profissionais a serem contratados")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(curso.ds_perfil_profissional))])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "8"
      }
    }, [_c('span', {
      staticClass: "cabecalho"
    }, [_vm._v("Especificação dos serviços a serem prestados")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(curso.ds_especificacao_servico))])])])])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.proposta) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Equipe do projeto")]), _vm._v(" "), _vm._l((_vm.proposta.equipes), function(equipe) {
    return _c('div', [_c('table', {
      staticClass: "table table-condensed table-bordered lista"
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Cargo no projeto")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(equipe.ds_cargo))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Quantidade")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(equipe.nr_quantidade))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("É remunerado pelo projeto?")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(('' + equipe.bt_remunerado) === '0' ? 'Não' : 'Sim'))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Forma de contratação")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(equipe.ds_forma_contratacao))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Perfil profissional pretendido")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar",
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v(_vm._s(equipe.ds_perfil_desejado))]), _vm._v(" "), _c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Carga horária semanal")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar"
    }, [_vm._v(_vm._s(equipe.dc_carga_horaria) + " horas")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "cabecalho"
    }, [_vm._v("Resumo das atividades")]), _vm._v(" "), _c('td', {
      staticClass: "ressaltar",
      attrs: {
        "colspan": "7"
      }
    }, [_vm._v(_vm._s(equipe.ds_resumo_atividades))])])])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
    staticClass: "caixa_texto",
    domProps: {
      "innerHTML": _vm._s(_vm.proposta.ds_resultados)
    }
  })]), _vm._v(" "), (_vm.proposta) ? _c('div', {
    staticClass: "box-body"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Orçamento do projeto - por atividade")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_vm._l((_vm.proposta.atividades), function(atividade) {
    return [_c('tr', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_c('td', {
      staticClass: "esquerda nome_atividade bl1 bl3 bl4"
    }, [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('td', {
      staticClass: "centralizado bl1 bl3"
    }, [_vm._v(_vm._s(atividade.nr_periodo_inicial))]), _vm._v(" "), _c('td', {
      staticClass: "centralizado bl1 bl3"
    }, [_vm._v(_vm._s(atividade.nr_periodo_final))]), _vm._v(" "), _c('td', {
      staticClass: "direita bl1 bl2 bl3",
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(atividade.itens_orcamentos, function(a) {
      return parseFloat(a.quantidade) * parseFloat(a.valor_unitario)
    }))))])]), _vm._v(" "), _vm._l((atividade.itens_orcamentos), function(item) {
      return _c('tr', [(!item.editando) ? [_c('td', {
        staticClass: "bl4 b3"
      }, [_c('span', {}, [(('' + item.origem).substr(0, 1) === '1') ? _c('span', [_vm._v("Fundação")]) : (('' + item.origem).substr(0, 1) === '2') ? _c('span', [_vm._v("Contrapartida")]) : (('' + item.origem).substr(0, 1) === '5') ? _c('span', [_vm._v("P.Estratégico")]) : _vm._e(), _vm._v(" "), (('' + item.adiantavel).substr(0, 1) === '1') ? _c('span', {
        staticClass: "adiantavel"
      }, [_vm._v(" (Adiantável)")]) : _vm._e()]), _vm._v(" "), _c('span', {
        staticClass: "esmaecido"
      }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), _c('div', {
        staticClass: "observacao esquerda"
      }, [_vm._v(_vm._s(item.observacao))])]), _vm._v(" "), _c('td', {
        staticClass: "centralizado b3"
      }, [_vm._v(_vm._s(item.periodo_inicial))]), _vm._v(" "), _c('td', {
        staticClass: "centralizado b3"
      }, [_vm._v(_vm._s(item.periodo_final))]), _vm._v(" "), _c('td', {
        staticClass: "centralizado b3"
      }, [_vm._v(_vm._s(item.quantidade))]), _vm._v(" "), _c('td', {
        staticClass: "centralizado b3"
      }, [_vm._v(_vm._s(_vm._f("real")(item.valor_unitario)))]), _vm._v(" "), _c('td', {
        staticClass: "centralizado b3 bl2"
      }, [_vm._v(_vm._s(_vm._f("real")(item.quantidade * item.valor_unitario)))])] : _vm._e()], 2)
    })]
  })], 2)])]) : _vm._e()])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table imprimir"
  }, [_c('tr', [_c('td', [_c('img', {
    staticClass: "logo_relatorio",
    attrs: {
      "src": "/static/img/logo-login.png"
    }
  })]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "direita"
  }, [_c('span', {
    staticStyle: {
      "font-size": "40px !important"
    }
  }, [_vm._v("Proposta")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Fundação")]), _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Proponente")]), _c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Terceiros")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "cabecalho",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Municípios de Desenvolvimento do Projeto")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    staticClass: "cabecalho"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
    staticClass: "cabecalho centralizado"
  }, [_vm._v("CPF")]), _vm._v(" "), _c('td', {
    staticClass: "cabecalho centralizado"
  }, [_vm._v("Contato")]), _vm._v(" "), _c('td', {
    staticClass: "cabecalho centralizado"
  }, [_vm._v("E-mail")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Público-alvo")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho centralizado"
  }, [_vm._v("Participantes diretos")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho centralizado"
  }, [_vm._v("Jovens atendidos")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho centralizado"
  }, [_vm._v("Mulheres atendidas")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "cabecalho"
  }, [_vm._v("Atividade / Recursos (itens do cronograma)")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho centralizado",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Período"), _c('br'), _vm._v("Início / Fim")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho centralizado"
  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho centralizado"
  }, [_vm._v("Valor Unitário")]), _vm._v(" "), _c('th', {
    staticClass: "cabecalho centralizado"
  }, [_vm._v("Valor Total")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-255aac42!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/proposta/ImprimirProposta.vue
// module id = 1881
// module chunks = 1